export const TENANT_EMSMC = 'emsmc';
export const TENANT_CONE_HEALTH = 'cone-health';

export const TENANT_NAME_EMSMC = 'EMS|MC';
export const TENANT_NAME_CONE_HEALTH = 'Cone Health';

export const LOGIN_EMSMC = '/azure/login';
export const LOGIN_CONE_HEALTH = '/cone-health-azure/login';

export const REQUEST_AUTHORIZE_URL_EMSMC = '/azure/authorize-url';
export const REQUEST_AUTHORIZE_URL_CONE_HEALTH = '/cone-health-azure/authorize-url';

export function isAzureAdEmail(email) {
    return email.match(/^[^@]+(@emsbilling\.com|@emsmc\.com|@conehealth\.com)$/);
}

export function goToAzureAdPasswordReset() {
    window.location.href = 'https://passwordreset.emsbilling.com';
}